import React, { useEffect, useState } from "react";
import { BsListTask } from "react-icons/bs";
import { MdPendingActions } from "react-icons/md";
import { LiaTasksSolid } from "react-icons/lia";
import axios from "axios";

const Dashboard = () => {
  const [pendingTasks, setPendingTasks] = useState(0);
  const [ongoingTasks, setOngoingTasks] = useState(0);
  const [completedTasks, setCompletedTasks] = useState(0);

  const [todaysTasks, setTodaysTasks] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pendingLoading, setPendingLoading] = useState(true);
  const [tasks, setTasks] = useState([]);
  const [day, setDay] = useState("Yesterday");
  const [date, setDate] = useState();

  const storedData = localStorage.getItem("Ananya Enterprize-Users-Data");
  const userData = storedData ? JSON.parse(storedData) : {};

  //Function to get all the tasks
  const getAllTasks = () => {
    setLoading(true);
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/task/get-all-tasks/?staffId=${userData._id}`,
    };

    axios
      .request(config)
      .then((response) => {
        setTasks(response.data.tasks);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error in getAllTasks: ", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllTasks();
  }, []);

  useEffect(() => {
    if (day === "Yesterday") {
      setDate(new Date(Date.now() - 86400000).toISOString().split("T")[0]);
    } else if (day === "Day before Yesterday") {
      setDate(new Date(Date.now() - 172800000).toISOString().split("T")[0]);
    } else if (day === "custom") {
      setFilteredTasks([]); // Clear tasks when custom is selected
      setDate(""); // Reset date to prevent automatic fetch
    }
  }, [day]);

  console.log("Date: ", date);

  //Function to get all the pending tasks filtered day-wise
  const getAllPendingTasks = () => {
    setPendingLoading(true);
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/task/get-all-tasks/?staffId=${userData._id}&date=${date}&status=Pending`,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getAllPendingTasks: ", response.data);
        setFilteredTasks(response.data.tasks);
        setPendingLoading(false);
      })
      .catch((error) => {
        console.log("Error in getAllPendingTasks: ", error);
        setPendingLoading(false);
      });
  };

  useEffect(() => {
    if (date) {
      getAllPendingTasks();
    }
  }, [date]);

  useEffect(() => {
    const ongoingCount = tasks?.filter(
      (task) => task.status === "Ongoing"
    ).length;
    const pendingCount = tasks?.filter(
      (task) => task.status === "Pending"
    ).length;

    const completedCount = tasks?.filter(
      (task) => task.status === "Completed"
    ).length;

    console.log("Ongoing Count: ", ongoingCount);
    setPendingTasks(pendingCount);
    setOngoingTasks(ongoingCount);
    setCompletedTasks(completedCount);

    setTodaysTasks(
      tasks?.filter((task) => {
        const taskDate = new Date(task.startDate).setHours(0, 0, 0, 0);
        const today = new Date().setHours(0, 0, 0, 0);
        return taskDate === today && task.status === "Pending";
      })
    );
  }, [tasks]);

  return (
    <div className="mx-2 my-6 md:my-8">
      <h1 className="text-3xl font-bold tracking-wide text-primary">
        Dashboard
      </h1>

      {/* Task Summary Cards */}
      <div className="mb-8 mt-2 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-16">
        {[
          {
            count: pendingTasks,
            color: "yellow",
            icon: <MdPendingActions color="orange" size={28} />,
            label: "Pending Tasks",
          },
          {
            count: ongoingTasks,
            color: "blue",
            icon: <BsListTask color="blue" size={28} />,
            label: "Ongoing Tasks",
          },
          {
            count: completedTasks,
            color: "green",
            icon: <LiaTasksSolid color="green" size={28} />,
            label: "Completed Tasks",
          },
        ].map((item, index) => (
          <div
            key={index}
            className={`flex flex-col rounded-xl bg-${item.color}-50 p-4 shadow-lg transition-transform duration-300 ease-in-out hover:scale-105`}
          >
            <div className="mb-3 flex items-center gap-6">
              <div className="rounded-lg bg-white p-3">{item.icon}</div>
              {loading ? (
                <div className="h-6 w-10 animate-pulse rounded-md bg-gray-200"></div>
              ) : (
                <h1 className="text-primaryTextColor text-xl font-extrabold tracking-wide md:text-2xl">
                  {item.count}
                </h1>
              )}
            </div>
            <p className="font-semibold tracking-wide text-[#555454]">
              {item.label}
            </p>
          </div>
        ))}
      </div>

      {/* Task Tables */}
      <div className="flex flex-col gap-4 md:flex-row">
        {[
          {
            title: "Tasks to be started today",
            data: todaysTasks,
            showDropDown: false,
            isLoading: loading,
          },
          {
            title: `Pending tasks of ${day === "custom" ? "" : day}`,
            data: filteredTasks,
            showDropDown: true,
            isLoading: pendingLoading,
          },
        ].map((section, index) => (
          <div
            key={index}
            className="max-h-96 w-full overflow-x-auto rounded-lg bg-white p-4 shadow-md md:w-1/2"
          >
            <div className="flex justify-between">
              <h2 className="text-md font-semibold text-primaryText md:text-lg">
                {section.title}
                {section.showDropDown && day === "custom" && (
                  <input
                    type="date"
                    onChange={(e) => setDate(e.target.value)}
                    className="rounded-lg focus:outline-none "
                  />
                )}
              </h2>

              {section.showDropDown && (
                <select
                  name="date"
                  id="date"
                  className="rounded-lg border border-gray-300 p-2 text-primaryText focus:outline-none focus:ring-1 focus:ring-blue-400 lg:w-auto"
                  onChange={(e) => setDay(e.target.value)}
                >
                  <option value="Yesterday">Yesterday</option>
                  <option value="Day before Yesterday">
                    Day before Yesterday
                  </option>
                  <option value="custom">Custom date</option>
                </select>
              )}
            </div>

            <table className="my-4 min-w-full overflow-y-visible rounded-md border-blue-200">
              <thead>
                <tr className="bg-blue-50">
                  <th className="rounded-tl-xl px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                    Sl
                  </th>
                  <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                    Name
                  </th>

                  <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                    Category
                  </th>
                  <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                    Location
                  </th>
                </tr>
              </thead>

              <tbody className="text-[13px] font-medium tracking-wide text-[#202224]">
                {section.isLoading ? (
                  Array(5)
                    .fill(null)
                    .map((_, i) => (
                      <tr key={i} className="border-b border-gray-200">
                        <td className="px-6 py-4">
                          <div className="h-4 w-6 animate-pulse rounded-md bg-gray-200"></div>
                        </td>
                        <td className="px-6 py-4">
                          <div className="h-4 w-24 animate-pulse rounded-md bg-gray-200"></div>
                        </td>
                        <td className="px-6 py-4">
                          <div className="h-4 w-20 animate-pulse rounded-md bg-gray-200"></div>
                        </td>

                        <td className="px-6 py-4">
                          <div className="h-4 w-28 animate-pulse rounded-md bg-gray-200"></div>
                        </td>
                      </tr>
                    ))
                ) : section.data.length > 0 ? (
                  section.data.map((task, i) => (
                    <tr key={i} className="border-b border-gray-200">
                      <td className="px-6 py-4">{i + 1}</td>
                      <td className="px-6 py-4">{task.name}</td>
                      <td className="px-6 py-4">{task.category?.name}</td>
                      <td className="px-6 py-4">{task.location}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={4}
                      className="py-10 text-center text-base text-gray-400"
                    >
                      No Tasks found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
